var _path, _path2;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFacebookStroke = function SvgFacebookStroke(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 48,
    viewBox: "0 0 23 48",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.875 0H15.0944C10.4772 0 5.34152 1.91468 5.34152 8.51356C5.36406 10.8129 5.34152 13.0149 5.34152 15.4932H0V23.8738H5.50682V48H15.6259V23.7146H22.3048L22.9091 15.4697H15.4515C15.4515 15.4697 15.4682 11.802 15.4515 10.7369C15.4515 8.12917 18.2036 8.27851 18.3691 8.27851C19.6788 8.27851 22.2251 8.28227 22.8788 8.27851V0H22.875Z",
    fill: "#3C5A9A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.875 0H15.0944C10.4772 0 5.34152 1.91468 5.34152 8.51356C5.36406 10.8129 5.34152 13.0149 5.34152 15.4932H0V23.8738H5.50682V48H15.6259V23.7146H22.3048L22.9091 15.4697H15.4515C15.4515 15.4697 15.4682 11.802 15.4515 10.7369C15.4515 8.12917 18.2036 8.27851 18.3691 8.27851C19.6788 8.27851 22.2251 8.28227 22.8788 8.27851V0H22.875Z",
    fill: "#0258FF"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFacebookStroke, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/facebook-stroke.19cff12c.svg";
export { ForwardRef as ReactComponent };